<template>
  <!-- nested dialog -->
  <el-dialog :visible="show" @close="closeDialog"  append-to-body>
    <el-dialog
      width="30%"
      :title="actionMessage"
      :visible.sync="actionVisible"
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div style="text-align:center">
        <el-button round type="" icon="now-ui-icons"  @click="actionVisible=false; progressing = false;">
          取消
        </el-button>
        <el-button round type="danger" icon="now-ui-icons"  @click="onActionConfirmed">
          確認
        </el-button>
      </div>
    </el-dialog>

    <template slot="title">
      <h5>款項異動<span class="text-muted">#{{ orderId }}</span></h5>
    </template>

    <div>

      <!-- Basic info data iterator -->
      <el-table :data="orderDataItems" :show-header="false">
        <el-table-column prop="key1" label="Key1">
          <template slot-scope="{row}"><strong>{{ row.key1 }}</strong></template>
        </el-table-column>
        <el-table-column prop="val1" label="Val1"></el-table-column>
      </el-table>
      <br/>
      <div>
        <el-row>
          <label><h6>異動項目</h6></label>
          <el-select v-model="paymentChange.item" clearable placeholder="選擇項目"
            @change="onChangeItemSelected" style="margin-left:20px">
            <el-option v-for="t in availableChangeTypes" :key="t.id"
              :label="t.name" :value="t.id">
            </el-option>
          </el-select>
        </el-row>
        <el-row>
          <label><h6>異動金額</h6></label>
          <el-input-number placeholder="輸入金額" v-model="paymentChange.amount"
            :min="0"
            maxlength="40" size="medium" clearable style="width:220px;margin-left:20px;">
          </el-input-number>   
        </el-row>
      </div>
      
      <div style="text-align:center">
        <el-button round type="" icon="now-ui-icons" :disabled="progressing" @click="closeDialog">
          取消
        </el-button>
        <el-button round type="danger" icon="now-ui-icons" :disabled="progressing || !paymentChange.item" :loading="progressing" @click="onPaymentChangeConfirmed">
          送出
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

import axios from 'axios';
import moment from 'moment';

// 需要取得店家BA，或者是API要處理
export default {
  name: 'PaymentChangeDialog',
  props: {
    show: Boolean,
    orderId: String
  },

  mounted() {
    if (this.orderId)
      this.fetchOrderData();
  },

  methods: {
    closeDialog() {
      this.$emit('close', false);
    },

    fetchOrderData() {
      this.loading = true;
      axios.get(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/orders/${this.orderId}/cart-snapshot`
        + `?reveal=${this.userType === 'gaa'? 'true': 'false'}`
      )
      .then(response => {
        this.order = response.data.order;
      })
      .catch(err => {
        console.error(`[DialogOrderDetail] fetchOrderData: failed to fetch snapshot`, err);

        //TODO: Make fallback request.
        return axios.get(
          `${process.env.VUE_APP_APIHOST}/${this.userType}/orders/${this.orderId}/cart`
          + `?reveal=${this.userType === 'gaa'? 'true': 'false'}`
        );
      })
      .then(response => {
        if (!response) return;//NOTE: Cart data has been retrieved.

        console.warn(`[DialogOrderDetail] fetchOrderData: tried fallback cart request.`, response.data);
        this.order = response.data.order;
      })
      .catch(err => {
        console.error(`[DialogOrderDetail] fetchOrderData: fallback request failed as well`, err);
        let message;
        if (err.data && err.data.message)
          message = err.data.message;
        this.$notify.error({
          title: '無法取得此訂單之明細！',
          message: message || ''
        });
      })
      .finally(() => {
        this.loading = false;
      });
    },

    // fetchBillingAccounts() {
     
    //   let apiHost = `https://apis-dev.ddc.ai/vas/v1/merchants/${this.vasMerchantId}/management/shops/${this.shopId}/billing-accounts`;
    //   // let apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/${this.vasMerchantId}/shops/${this.shopId}billing-accounts`;
    //   // let apiHost = 'http://localhost:3000/vas/v1/merchants/ddcstore/management/billing-accounts';
    //   axios.get(
    //     `${apiHost}`
    //   )
    //   .then(response => {
    //     console.log(`fetchBillingAccounts`, response.data);

    //     if (Array.isArray(response.data)) {
    //       this.accounts = [ ];
    //       response.data.forEach(account => {
    //         this.accounts.push({ id: account['baId'], name: account['baName'] });
    //       });
    //     }
    //     else {
    //       throw new Error(`Cannot resolve response data of account list.`);
    //     }
        
    //   })
    //   .catch(err => {
    //     console.error(`Cannot fetch billing account`, err);
    //     alert('找不到對應的儲值帳戶');
    //   });
    // },

    onChangeItemSelected () {
      const item = this.availableChangeTypes.find(i=> i.id === this.paymentChange.item);
      this.paymentChange.remark = item.name;
      this.paymentChange.type = item.type;
      this.paymentChange.url = item.url;
      console.log(JSON.stringify(this.paymentChange))
    },

    onPaymentChangeConfirmed(){
      if (this.progressing) return;
      this.progressing = true;
      if ((!this.paymentChange.amount) || Number(this.paymentChange.amount) <= 0 ) {
        alert(`金額必須大於0!`);
        this.progressing = false;
        return;
      }
      this.actionMessage = `${this.paymentChange.remark} - 金額：＄${this.paymentChange.amount}`;
      this.actionVisible = true;
      
    },
    onActionConfirmed () {
      this.actionVisible = false;
      let url = this.paymentChange.url;
      // 扣點
      // {
      //   "shopId": "D_pxmE8ML12",
      //   "merchantOrderId": "0022331234",//不給的話就後端隨機產生
      //   "amount": 75,
      //   "type": "git",
      //   "remark": "物流費"
      // }
      // 退還扣點
      // {
      //   "shopId": "D_pxmE8ML12",
      //   "merchantOrderId": "2212161603141721A4D4d",
      //   "amount": 30,
      //   "remark": "物流費部分退還"
      // }
      let data = {
        shopId: this.shopId,
        merchantOrderId: `${this.orderId}-${moment().valueOf()}`,
        amount: this.paymentChange.amount,
        type: this.paymentChange.type, 
        remark: `${this.paymentChange.remark}（${this.orderId}）`
      }
      console.log('data:' + JSON.stringify(data))
      axios.request({
        method: 'POST',
        url,
        data
      })
      .then(response => {
        console.log('done.');
        this.$notify.success({
          title: `${this.paymentChange.remark}（${this.orderId}） 完成！`,
        });
        this.closeDialog();
      })
      .catch(err => {
        console.error(`[DialogPaymentChange] action failed`, err);
        let message;
        if (err.data && err.data.message)
          message = err.data.message;
        this.$notify.error({
          title: `${this.paymentChange.remark}（${this.orderId}） 失敗！`,
          message: message || ''
        });
      })
      .finally(() => {
        this.progressing = false;
      });
    }

  },

  data() {
    return {
      loading: false,
      order: { },
      progressing: false,
      vasMerchantId: 'ddcstore',
      paymentChange: {
        amount: undefined,
        item: undefined,
        url: undefined,
        remark: '',
        type: ''
      },
      actionVisible: false,
      actionMessage: undefined
    };
  },

  computed: {
    availableChangeTypes() {
      return [
        {
          id: 1,
          type: 'git-cs',
          name: '加收物流費', //減項
          url: `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/${this.vasMerchantId}/transactions/redeem`,
          // url: `https://apis-dev.ddc.ai/vas/v1/merchants/${this.vasMerchantId}/transactions/redeem`
        },
        {
          id: 2,
          type: 'git-cs',
          name: '酌收空車費', //減項,
          url: `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/${this.vasMerchantId}/transactions/redeem`
          // url: `https://apis-dev.ddc.ai/vas/v1/merchants/${this.vasMerchantId}/transactions/redeem`
        },
        {
          id: 3,
          type: 'git-cs',
          name: '爭議退款', //加項
          url: `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/${this.vasMerchantId}/transactions/rebate`,
          // url: `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/${this.vasMerchantId}/aaa`
        },
      ]
    },

    orderDataItems() {
      // List data items to be displayed.
      let items = [
        { key: '訂單編號（ID）', val: this.order['order_id'] },
        // { key: '運費', val: `$${Number(this.order['delivery_fee']).toLocaleString()}` },
        // { key: '店家負擔運費', val: `$${Number(this.order['shop_covered_fee']).toLocaleString()}` },
        { key: '訂單金額', val: `$${Number(this.order['amount']).toLocaleString()}` },
        { key: '交易類型', val: '運費' },
      ];


      // Convert to table column structures for this data iterator.
      let ret = [ ];
      for (let i=0; i<items.length; i++) {
        let temp = {
          'key1': items[i].key,
          'val1': items[i].val,
        };
        ret.push(temp);
      }
      return ret;
    },
    shopId() {
      if (this.order && this.order.content){
        let content = JSON.parse(this.order.content);
        return content.shopId || '';
      } 
      return ''
    },
    userType() {
      return this.$store.getters.userType;
    }
  },

  filters: {
    toDateTimeString(ts) {
      return moment.unix(ts).format('YYYY/M/D h:mmA');
    },
  },

  watch: {
    orderId: function(id) {
      this.fetchOrderData();
    }
  }
}
</script>

<style scoped>

</style>